import http from "./httpService";

const apiEndpoint = "/States";


export function getStates() {
  return http.get(apiEndpoint);
}